/**
 * @fileoverview Minimal in-memory metrics counters with console flushing.
 * Non-invasive: safe in dev; can be replaced by Sentry/Otel later.
 */

/** @type {Record<string, number>} */
const counters = Object.create(null);

/**
 * Increment a counter by n (default 1).
 * @param {string} name
 * @param {number} [n]
 */
export function increment(name, n = 1) {
  counters[name] = (counters[name] || 0) + (Number.isFinite(n) ? n : 1);
}

/**
 * Set a gauge-like value.
 * @param {string} name
 * @param {number} value
 */
export function set(name, value) {
  counters[name] = Number(value) || 0;
}

/**
 * Snapshot current counters.
 */
export function snapshot() {
  return { ...counters };
}

/**
 * Flush counters to console at info level.
 * @param {string} [label]
 */
export function flush(label = 'metrics') {
  try {
    // Lazy import to avoid circular deps
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const logger = require('../utils/logger').default || require('../utils/logger');
    logger.info(`[${label}]`, { ...counters });
  } catch (_) {
    // Fallback
    // eslint-disable-next-line no-console
    console.debug(`[${label}]`, { ...counters });
  }
}

export default { increment, set, snapshot, flush };
